import VueRouter, { RouteConfig } from 'vue-router'

const Edit = () => import('../views/SchoolEdit.vue')

export const editRoute: RouteConfig = {
  path: '/school-edit',
  name: 'school_edit',
  component: Edit,
  meta: {
    title: '',
  },
}

export default [editRoute]

export function navigateToSchoolEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}
